import LightboxGallery from 'components/Shared/ImageLightBox/ImageLightBox';
import React from 'react';
import Video from 'react-player';
import { Modal } from '@material-ui/core';
import { DocumentType } from './DocumentItemTypes';

export const RenderFileView: React.FC<{
  fileExtention: string;
  document: DocumentType;
  showModal: boolean;
  onClose: () => void;
}> = React.memo(({ fileExtention, document, showModal, onClose }) => {
  if (fileExtention === 'pdf' || fileExtention === 'file') return null;
  if (fileExtention === 'image')
    return (
      <LightboxGallery images={[{ url: document.path }]} incomingIndex={0} showGallery={showModal} onClose={onClose} />
    );
  if (fileExtention === 'video')
    return (
      <Modal
        style={{
          zIndex: 10,
          position: 'absolute',
          width: '50%',
          height: '50%',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          margin: 'auto',
        }}
        open={showModal}
        onClose={onClose}
      >
        <Video width={'100%'} height={'100%'} url={document.path} controls playing />
      </Modal>
    );
  return null;
});
